var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpectrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 20",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5461c8;}.b{fill:#c724b1;}.c{fill:#e4002b;}.d{fill:#ff6900;}.e{fill:#f6be00;}.f{fill:#97d700;}.g{fill:#00ab84;}.h{fill:#00a3e0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 19,
    width: 21,
    height: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 39,
    width: 21,
    height: 20
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 59,
    width: 21,
    height: 20
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 79,
    width: 21,
    height: 20
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 99,
    width: 21,
    height: 20
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 119,
    width: 21,
    height: 20
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 139,
    width: 21,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectrum);
export default __webpack_public_path__ + "static/media/spectrum.21a4e6b1e15ecc27a78cef33bd35bd1c.svg";
export { ForwardRef as ReactComponent };